import { useGetUnitLeases } from '@/api/units/get-unit-leases'
import { LeaseStatus } from '@/models/features'
import { getResidentFullName } from '@/utils/units'

const ASSIGNABLE_LEASE_STATUSES: LeaseStatus[] = ['Applicant', 'Current', 'Future', 'Notice']

/** Residents of the unit that can be assigned new work: current and future ones. */
export const useUnitAssignableResidents = (unitId: string) => {
  const { data: leases = [], isLoading } = useGetUnitLeases({ unitId })

  const options = new Map<number, { label: string; value: number }>()
  leases
    .filter(({ leaseStatus }) => leaseStatus && ASSIGNABLE_LEASE_STATUSES.includes(leaseStatus))
    .flatMap(({ residents }) => residents)
    .forEach((resident) => {
      if (resident.clientId === null || options.has(resident.clientId)) return

      options.set(resident.clientId, {
        label: getResidentFullName(resident) || resident.email || '',
        value: resident.clientId,
      })
    })

  return { isLoading, options: [...options.values()] }
}
